<div class="wrapper--spacing-horizontal">
  @if (isLoaded()) {
    <app-fertilizers-table
      [fertilizers]="initialStockFertilizers"
      title="initialStock"
      [showInitialStockMatchesRvo]="true"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="notDeliveredFertilizers"
      title="isNotDelivered"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="deliveredFertilizers"
      title="isDelivered"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="dispatchedFertilizers"
      title="dispatched"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="closingStockFertilizers"
      title="closingStock"
    ></app-fertilizers-table>

    <h3 class="text--h5">{{ 'comments' | translate }}</h3>
    <app-fertilizer-comment></app-fertilizer-comment>
  }
</div>
